<template>
  <div>
    <TableRow>
      <Row slot="left" verticalCenter>
        <Col :xs="8" :m="4">
          <Copy element="div" bold>
            {{ $t('cs.analysis.carePossibility.modal-1.table.row-1') }}
          </Copy>
        </Col>
        <Col :xs="4" :m="2">
          <Input
            name="modal1"
            type="number"
            :min="0"
            :max="160"
            @input="input"
            :value="hourResult"
          />
        </Col>
      </Row>
      <template slot="right">{{ formatNumber(hourResult * exampleHourPrice, 0) }} €</template>
    </TableRow>

    <TableRow>
      <Copy element="div" bold slot="left">
        {{ $t('cs.analysis.carePossibility.modal.table.row-2') }}
      </Copy>
      <template slot="right">{{ -formatNumber(facts.pflegegeld, 0) }} €</template>
    </TableRow>

    <TableRow>
      <Copy element="div" bold slot="left">
        {{ $t('cs.analysis.carePossibility.modal.table.row-3') }}
      </Copy>
      <template slot="right">{{ -formatNumber(facts.entlastungsbetrag, 0) }} €</template>
    </TableRow>

    <Copy size="s">
      {{ $t('cs.analysis.carePossibility.modal-1.example.legal') }}
    </Copy>

    <Row class="u-padding__vertical--3">
      <Col :xs="10">
        <Headline size="s" noMargin>
          {{ $t('cs.analysis.carePossibility.modal.example.personalContribution') }}
        </Headline>
      </Col>
      <Col :xs="2" right>
        <Headline color="tertiaryDark" size="s" noMargin>{{ formatNumber(result, 0) }} €</Headline>
      </Col>
    </Row>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Input from '@/objects/Forms/BaseInput';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

import TableRow from './TableRow';

import { formatNumber } from '@/helpers/formatter';

export default {
  name: 'TableMaintenance',
  props: {
    facts: Object,
  },
  components: {
    Headline,
    Copy,
    Input,
    Row,
    Col,
    TableRow,
  },
  data() {
    return {
      formatNumber,
      hourResult: 0,
      result: 0,
      exampleHourPrice: 30,
    };
  },
  watch: {
    hourResult: function () {
      let sum = this.hourResult * this.exampleHourPrice;
      if (Number.isNaN(sum)) {
        sum = 0;
      }
      const res = sum - this.facts.pflegegeld - this.facts.entlastungsbetrag;
      this.result = res < 0 ? 0 : res;
    },
  },
  methods: {
    input(value) {
      this.hourResult = parseInt(value, 10);
    },
  },
};
</script>
